import PropTypes from "prop-types";
import React, { useState } from "react";
import { DropdownItem } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import images from "../../assets/images";
import moment from "moment";
import { Images } from "../../constants/images";
import getStorageData from "../../Utils/getStorageData";

const Header = (props) => {
  const navigate = useNavigate();
  const [megaMenu, setmegaMenu] = useState(false);
  const date = new Date();

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img
                    src={images.logo}
                    alt=""
                    height="40"
                    style={{ borderRadius: 4 }}
                  />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img
                    src={images.logo}
                    alt=""
                    height="40"
                    style={{ borderRadius: 4 }}
                  />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <box-icon name="menu"></box-icon>
              {/* <i className="fa fa-bars" style={{ color: 'black' }} /> */}
            </button>
            <div
              style={{
                // width: '100%',
                marginTop: 7,
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              {(getStorageData().userType === 0 &&
                props.activeRoute === "Dashboard") ||
              (getStorageData().userType === 0 &&
                props.activeRoute === "User & Device Dashboard") ? (
                <Dropdown
                  className="dropdown-mega ms-2"
                  isOpen={megaMenu}
                  toggle={() => {
                    setmegaMenu(!megaMenu);
                  }}
                >
                  <DropdownToggle
                    className="btn header-item "
                    caret
                    tag="button"
                  >
                    <h5
                      style={{
                        color: "#000",
                        fontWeight: "bold",
                        fontSize: 17,
                        display: "flex",
                      }}
                    >
                      <span className="d-none d-md-flex">
                        {props.activeRoute === "Dashboard"
                          ? "Request Dashboard"
                          : props.activeRoute}{" "}
                      </span>
                      <span style={{ marginLeft: 10 }}>
                        <img src={Images.downArrow} />
                      </span>
                    </h5>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      className="dropdown-megamenu"
                      onClick={() => navigate("/dashboard/request-dashboard")}
                    >
                      Request Dashboard
                    </DropdownItem>
                    <DropdownItem
                      className="dropdown-megamenu"
                      onClick={() =>
                        navigate(
                          "/dashboard/request-dashboard/device-dashboard"
                        )
                      }
                    >
                      User & Device Dashboard
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              ) : (
                <h5 style={{ color: "#000", fontWeight: "bold", fontSize: 17 }}>
                  {props.activeRoute}
                </h5>
              )}
            </div>
          </div>

          <div
            style={{
              // width: '100%',
              marginTop: 7,
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              color: "#000000",
              fontSize: 15,
              fontWeight: "500",
            }}
          >
            {moment(date).format("dddd, MMMM DD, YYYY")}
          </div>
          <div className="d-flex">
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

export default Header;
